import { Component, Input, OnInit } from "@angular/core";
import * as Highcharts from "highcharts";

import HighchartsMore from "highcharts/highcharts-more";
HighchartsMore(Highcharts);
import Funnel from "highcharts/modules/funnel";
Funnel(Highcharts);
@Component({
  selector: "app-pyramidchart",
  templateUrl: "./pyramid.component.html",
  styleUrls: ["./pyramid.component.scss"],
})
export class PyramidComponent implements OnInit {
  chartOptions = {};
  highcharts = Highcharts;
  constructor() {}

  ngOnInit(): void {
    this.plotGraph();
  }
  plotGraph() {
    return (this.chartOptions = {
      chart: {
        type: "pyramid",
        spacing: 0,
        spacingBottom: 0,
        spacingTop: 50,
        style: {
          fontFamily: "sfpro-r",
        },
      },
      credits: {
        enabled: false,
      },
      title: {
        text: "",
        x: -50,
        enabled: false,
      },
      tooltip: {
        enabled: false,
      },
      plotOptions: {
        series: {
          dataLabels: {
            enabled: true,
            inside: true,
            format: "<b>{point.name}</b>",
            softConnector: true,
          },
          center: ["40%", "50%"],
          width: "80%",
          slicedOffset: 50,
        },
      },
      legend: {
        enabled: false,
      },
      series: [
        {
          name: "Unique users",
          data: [
            { name: "Unsafe Acts", y: 1200, color: "#009b6a" },
            { name: "Unsafe Conditions", y: 1200, color: "#009b6a" },
            { name: "Near Misses", y: 1200, color: "#89cd25" },
            { name: "First Aid", y: 1200, color: "#ffff1f" },
            { name: "Lost Time", y: 1200, color: "#ff9300" },
            { name: "FATAL", y: 1200, color: "#ff0000" },
          ],
          // stacking: "10%",
        },
      ],

      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 350,
            },
            chartOptions: {
              plotOptions: {
                series: {
                  dataLabels: {
                    inside: true,
                    style: {
                      color: "black",
                      stroke: "none",
                      borderColor: "none",
                    },
                  },
                  center: ["50%", "50%"],
                  width: "100%",
                },
              },
            },
          },
        ],
      },
    });
  }
}
